import { useNavigate } from "react-router-dom";

const BrandsSection = () => {
  const products = [
    {
      name: "Industrial Machinery",
      icon: "🏭",
      category: "Heavy Equipment",
      description: "CNC machines, lathes, milling equipment",
    },
    {
      name: "Industrial Parts",
      icon: "🔩",
      category: "Components",
      description: "Spare parts, bearings, motors",
    },
    {
      name: "Precision Tools",
      icon: "⚙️",
      category: "Measurement",
      description: "Cutting tools, measuring instruments",
    },
    {
      name: "Industrial Solutions",
      icon: "🛠️",
      category: "Services",
      description: "Installation & technical support",
    },
  ];
  const navigate = useNavigate();
  const handlecontact = () => {
    navigate("/contact");
  };

  return (
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-gray-50 rounded-full px-4 py-2 mb-4 border border-gray-200">
            <div className="w-1.5 h-1.5 bg-[#00d9ff] rounded-full"></div>
            <span className="text-sm font-semibold text-[#002946]">
              OUR SPECIALIZATION
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#002946] mb-4">
            Our <span className="text-[#00d9ff]">Product Range</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm sm:text-base">
            High-quality machinery, industrial parts, precision tools, and
            comprehensive solutions
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-4xl mb-4">{product.icon}</div>
              <h3 className="text-lg font-bold text-[#002946] mb-2">
                {product.name}
              </h3>
              <p className="text-sm text-[#00d9ff] font-semibold mb-3">
                {product.category}
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                {product.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center relative">
          {/* Soft ambient glow */}
          <div className="absolute -inset-3 rounded-[30px] bg-gradient-to-r from-blue-500/[0.07] via-transparent to-teal-500/[0.07] blur-2xl" />

          <div
            className="
    relative
    overflow-hidden
    rounded-[24px]
    border border-slate-200/50
    bg-gradient-to-br from-slate-900 via-[#062d47] to-[#073f5c]
    px-6 py-8 sm:px-10 sm:py-9
    shadow-[0_3px_8px_rgba(15,23,42,0.04),0_15px_35px_rgba(15,23,42,0.10),0_35px_70px_rgba(15,23,42,0.12)]
  "
          >
            {/* Background glow */}
            <div
              className="
      absolute -top-24 -right-20
      w-64 h-64
      rounded-full
      bg-blue-500/10
      blur-[80px]
      pointer-events-none
    "
            />

            <div
              className="
      absolute -bottom-24 -left-20
      w-64 h-64
      rounded-full
      bg-teal-400/10
      blur-[80px]
      pointer-events-none
    "
            />

            <div className="relative z-10">
              {/* Small label */}
              <div className="inline-flex items-center gap-2 mb-3">
                <span className="w-1.5 h-1.5 rounded-full bg-teal-400" />

                <span
                  className="
          text-[10px] sm:text-[11px]
          font-bold
          uppercase
          tracking-[0.18em]
          text-blue-200
        "
                >
                  Industrial Solutions
                </span>
              </div>

              {/* Heading */}
              <h3
                className="
        text-xl sm:text-2xl lg:text-3xl
        font-extrabold
        tracking-tight
        text-white
        mb-2
      "
              >
                Need Industrial Solutions?
              </h3>

              {/* Description */}
              <p
                className="
        text-slate-300
        text-sm sm:text-base
        leading-6
        mb-6
        max-w-xl
        mx-auto
      "
              >
                Get expert consultation and competitive quotes for your
                machinery requirements.
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  onClick={handlecontact}
                  className="
            w-full sm:w-auto
            inline-flex items-center justify-center gap-2
            bg-white
            text-slate-900
            px-6 py-3
            rounded-xl
            font-bold
            text-sm
            border border-white/80
            shadow-[0_5px_18px_rgba(0,0,0,0.15)]
            hover:bg-blue-50
            hover:-translate-y-0.5
            hover:shadow-[0_9px_24px_rgba(0,0,0,0.20)]
            active:scale-95
            transition-all duration-300
          "
                >
                  Free Consultation
                  <span className="text-blue-600 text-base">→</span>
                </button>

                <button
                  onClick={handlecontact}
                  className="
            w-full sm:w-auto
            inline-flex items-center justify-center gap-2
            bg-white/5
            backdrop-blur-sm
            border border-white/25
            text-white
            px-6 py-3
            rounded-xl
            font-bold
            text-sm
            hover:bg-white
            hover:text-slate-900
            hover:border-white
            active:scale-95
            transition-all duration-300
          "
                >
                  Request Quote
                  <span className="text-sm">→</span>
                </button>
              </div>

              {/* Bottom status */}
              <div className="flex items-center justify-center gap-2 mt-4">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />

                <p className="text-slate-400 text-xs">
                  Expert support for your machinery requirements
                </p>
              </div>
            </div>

            {/* Bottom accent */}
            <div
              className="
      absolute bottom-0
      left-12 right-12
      h-px
      bg-gradient-to-r
      from-transparent
      via-blue-400/40
      to-transparent
    "
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
